var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 0H3.2C1.43269 0 0 1.43269 0 3.2V28.8C0 30.5673 1.43269 32 3.2 32H28.8C30.5673 32 32 30.5673 32 28.8V3.2C32 1.43269 30.5673 0 28.8 0Z",
    fill: "#EE741F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 8.7998C20.732 8.7998 24.05 12.0042 24.3741 16.0668C25.9824 16.3908 27.2 17.852 27.2 19.5998C27.2 21.5848 25.6299 23.1998 23.7 23.1998H9.00002C6.68407 23.1998 4.80002 21.2619 4.80002 18.8798C4.80002 16.4977 6.68407 14.5598 9.00002 14.5598H9.14317C10.035 11.1884 13.1216 8.7998 16.7 8.7998ZM16.7 10.2398C13.5903 10.2398 10.9355 12.4153 10.3881 15.413C10.3258 15.7532 10.0367 15.9998 9.70002 15.9998H9.00002C7.45617 15.9998 6.20002 17.2918 6.20002 18.8798C6.20002 20.4678 7.45617 21.7598 9.00002 21.7598H23.7C24.8582 21.7598 25.8 20.791 25.8 19.5998C25.8 18.4086 24.8582 17.4398 23.7 17.4398C23.3136 17.4398 23 17.1172 23 16.7198C23 13.1468 20.1738 10.2398 16.7 10.2398ZM18.3051 14.7708C18.5785 14.4896 19.0216 14.4896 19.2949 14.7708C19.5683 15.0519 19.5683 15.5077 19.2949 15.7888L15.7949 19.3888C15.6581 19.5296 15.4792 19.5998 15.3 19.5998C15.1208 19.5998 14.942 19.5296 14.8051 19.3888L12.7051 17.2288C12.4318 16.9477 12.4318 16.4919 12.7051 16.2108C12.9785 15.9296 13.4216 15.9296 13.6949 16.2108L15.3 17.8614L18.3051 14.7708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabackup);
export default __webpack_public_path__ + "static/media/databackup.2e7b25ce582adb710aa2704cf57b41ce.svg";
export { ForwardRef as ReactComponent };